export class ListNotificationsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "notifications",
            "baseName": "notifications",
            "type": "Array<Notification>",
            "format": ""
        },
        {
            "name": "pagination",
            "baseName": "pagination",
            "type": "Pagination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListNotificationsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
